<template>
  <div class="register absolute" style="background:#fff;">
    <van-nav-bar
      :title="$t('m.dl_span7')"
      @click-left="onClickLeft"
      left-arrow
    ></van-nav-bar>
    <div class="shading" style="padding:0 40px;">
      <div
        class="pictrue acea-row row-center-wrapper"
        style="height: 0.8rem;"
      ></div>
      <div class="biaoti">
        <div style="display:flex;align-items:center;">
          <img
            src="../../assets/images/img/img/logo.png"
            style="border-radius:15px; width: 180px; height: 60px;"
            alt=""
          />
        </div>
        {{ $t("m.dl_span03") }}！
      </div>
    </div>
    <div class="register_block">
      <div class="register_block_list">
        <country-code-selector
          style="background-color:#fff;"
          :countryCode.sync="value"
        ></country-code-selector>
        <input
          v-model="account"
          :placeholder="$t('m.dl_span2')"
          style="padding-left:10px;"
        />
      </div>
      <div class="register_block_list">
        <input v-model="password" :placeholder="$t('m.dl_span3')" />
      </div>
      <div class="register_block_list">
        <input v-model="password2" :placeholder="$t('m.dl_span14')" />
      </div>

      <van-button class="register_submit" @click="registerReset">{{
        $t("m.tijiao")
      }}</van-button>
      <!-- <div class="register_mgs">
        <p class="register_zq">
          <img src="../../assets/images/new/hongxuan.png" />
        </p>
        <p class="register_trip" @click="$router.push({ name: 'xuzhi' })">
          登录/注册即代表您同意我们的使用条款和条件
        </p>
      </div> -->
    </div>
    <div
      v-if="show"
      style="background: rgba(0, 0, 0, 0.5);position: fixed;width: 100%;height: 100%;left:0;top:0;display: flex;align-items: center;justify-content: center;"
    >
      <div
        style="background: rgba(0, 0, 0, 0.7);width:130px;height:130px;border-radius:8px;text-align:center;line-height:130px;color:#fff;font-size:16px;"
      >
        加载中。。。
      </div>
    </div>
  </div>
</template>

<script>
import { register } from "@api/user";
import { validatorDefaultCatch } from "@utils/dialog";
import { required } from "@utils/validate";
import countryCodeSelector from "@components/CodeSelector/components/index";
export default {
  components: {
    countryCodeSelector
  },
  name: "Register",
  data: function() {
    return {
      value: 86,
      show: false,
      account: "",
      password: "",
      password2: ""
    };
  },
  mounted: function() {
    const inv = this.$route.query.invite;
    if (inv != null && inv !== "") {
      this.password2 = String(inv);
    }
  },
  methods: {
    async registerReset() {
      var that = this;
      const { account, password, password2 } = that;
      try {
        await that
          .$validator({
            account: [required(required.message("手机号码"))],
            password: [required(required.message("密码"))],
            password2: [required(required.message("邀请码"))]
          })
          .validate({ account, password, password2 });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      this.show = true;
      register({
        area: this.value,
        mobile: that.value + that.account,
        password: that.password,
        invite: that.password2
      })
        .then(res => {
          this.show = false;
          that.$dialog.success(res.msg).then(() => {
            that.$router.push({ name: "Login" });
          });
        })
        .catch(res => {
          this.show = false;
          this.$dialog.error(res.response.data.msg);
        });
    },
    onClickLeft() {
      this.$router.go(-1);
    }
  }
};
</script>
<style scoped lang="less">
.biaoti {
  /* text-align: center; */
  font-size: 25px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img {
    width: 80px;
    height: 80px;
  }
}
.register_zq {
  width: 15px;
  height: 15px;
}
.register_zq img {
  border-radius: 6px;
  width: 100%;
  height: 100%;
  display: block;
}
.register_mgs {
  height: 40px;
  display: flex;
  align-items: center;
  font-size: 12px;

  /* padding: 15px 0px; */
  // justify-content: center;
}
.register_trip {
  font-size: 12px;
  color: #666;
  margin-left: 4px;
}
.register_submit {
  width: 100%;
  margin: 0 auto;
  height: 45px;
  background: var(--bg-color);
  border-radius: 30px;
  margin-top: 40px;
  text-align: center;
  line-height: 40px;
  color: #ffffff;
  border: 0px solid;
  font-size: 15px;
  font-weight: bold;
}
.register_block {
  padding: 0 40px;
  margin-top: 20px;
}
.register_block_list {
  width: 100%;
  height: 50px;
  padding: 0 0px;
  /* background: #f1f1f3; */
  /* border-radius: 5px; */
  display: flex;
  align-items: center;
  font-size: 14px;

  border-bottom: 1px solid #eee;
}
.register_block_list input {
  line-height: 50px;
  height: 50px;
  width: 100%;
  font-size: 15px;
}
.register_tit {
  display: flex;
  align-items: center;
  position: relative;
  justify-content: center;
  padding: 5px;
}
.register_tit img {
  width: 30px;
  height: 30px;
  position: absolute;
  left: 15px;
}
.register_tit p {
  text-align: center;
  text-align: center;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
  line-height: 35px;
}
/* 清除浮动*/
.am-fl {
  float: left;
}
.am-fr {
  float: right;
}
.am-cf:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.am-cf {
  zoom: 1;
}
/deep/ .van-nav-bar .van-icon {
  color: #333;
}
/deep/ .flag-list-box {
  background: #fff;
}
/deep/ .flag.flag-cf {
  display: none;
}
/deep/ .flag {
  display: none;
}
/deep/ .country-name {
  display: none;
}
/deep/ .area-codeNum {
  display: none !important;
}
/deep/ .intl-tel-input-container {
  padding-left: 3px !important;
  border-right: 1px solid #eee !important;
}
</style>
